import { render, staticRenderFns } from "./backTop.vue?vue&type=template&id=2e68519a&scoped=true&"
import script from "./backTop.vue?vue&type=script&lang=js&"
export * from "./backTop.vue?vue&type=script&lang=js&"
import style0 from "./backTop.vue?vue&type=style&index=0&id=2e68519a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68519a",
  null
  
)

export default component.exports